<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
 
    <!-- Data CTA -->
    <CCardBody ref="mycardloader"> 
      <CRow>
        <div class="col-sm-12 col-xl-12">
            <h5>Filter</h5>
        </div>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Tanggal Pelaksanaan</label>
            <input type="text" name="daterange" id class="form-control" placeholder="Pilih Tanggal" autocomplete="off"/>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol sm="6" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #nama_level="{item}">
              <td class="py-2">{{item.nama_level ? item.nama_level : "-"}}</td>
            </template>
            <template #biaya="{item}">
              <td
                class="py-2"
                align="left"
              >Rp. {{formatPrice(item.biaya) ? formatPrice(item.biaya) : "-"}}</td>
            </template>
            <template #tanggal_mulai="{item}">
              <td class="py-2">{{item.tanggal_mulai ? item.tanggal_mulai : "-"}}</td>
            </template>
            <template #tanggal_berakhir="{item}">
              <td class="py-2">{{item.tanggal_berakhir ? item.tanggal_berakhir : "-"}}</td>
            </template>
            <template #lokasi="{item}">
              <td class="py-2">{{item.lokasi ? item.lokasi : "-"}}</td>
            </template>
            <template #kapasitas="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.kapasitas ? item.kapasitas : "-"}}</td>
            </template>
            <template #sisa="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.sisa ? item.sisa : "-"}}</td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <router-link :to="'/sertifikasi/RplWorkshop/data-rpl-cta/'+item.id_sertifikasi_rpl" style="display:none">
                  <CButton color="warning" class="btn-sm text-white" square>
                    <font-awesome-icon icon="users" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <router-link :to="'/sertifikasi/master-rpl-cta/edit/'+item.id_sertifikasi_rpl">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mx-1" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" 
          :active-page.sync="currentPage" 
          :pages="pagination.totalPages" 
          @click="pageChange"
          responsive />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data CTA -->
</template>
<script>
import RplCTAService from "../../../../services/sertifikasi/master-rpl-cta.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "kode_rpl",
    label: "Kode",
    sorter: true,
    filter: false
  },
  {
    key: "nama_rpl",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "biaya",
    label: "Harga",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_mulai",
    label: "Tanggal Dimulai",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_berakhir",
    label: "Tanggal Berakhir",
    sorter: true,
    filter: false
  },
  {
    key: "lokasi",
    label: "Lokasi",
    sorter: true,
    filter: false
  },
  {
    key: "kapasitas",
    label: "Kapasitas",
    sorter: true,
    filter: false
  },
  {
    key: "sisa",
    label: "Sisa",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "RplCta",
  data() {
    return {
      search: "",
      pageSize: "",
      items: [],
      Level: [],
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      loading: true
    };
  },
  watch: {
    search : function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        vm.getData("0", vm.pageSize, vm.search);

      }, 1000);
    },
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
        },
        function(start, end, label) {
          // comment console console.log(
            
        }
      );
    });
    this.getData("0", this.pageSize, "default");
    // this.getData(currentPage,kategoriRpl);
  },
  
  methods: {
    changePageSize(e) {
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search);
    },

    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item) {
      var vm = this;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            RplCTAService.deleteRplCTA(item.id_sertifikasi_rpl)
            .then(response => {
              vm.alertSuccess();
              vm.getData("0", "10", "default");
            })
            .catch(error => {
              vm.alertError();
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.mycardloader,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      RplCTAService.getRplCTA(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          setTimeout(() => loader.hide(), 1000);
          // loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>